<template>
  <SubmitDemo />
</template>

<script>
import SubmitDemo from "@/components/demos/SubmitDemo.vue";

export default {
  name: "SubmitDemoPage",
  components: { SubmitDemo },
  metaInfo: {
    title: "Submit Demo",
  },
};
</script>

<style lang="scss" scoped></style>
